import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Suppress known-harmless Radix portal cleanup errors that surface
// during fast tab/dialog transitions in development.
if (typeof window !== "undefined") {
  const HARMLESS = /removeChild.*not a child|insertBefore.*not a child|appendChild.*null/i;
  window.addEventListener("error", (e) => {
    if (e?.message && HARMLESS.test(e.message)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    const msg = String(e?.reason?.message || e?.reason || "");
    if (HARMLESS.test(msg)) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
